/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 滞在先情報
 */
export interface PostCheckinTravelersRequestTravelersInnerRegulatoryDetailsSecondaryDocumentsInnerAddress {
  /**
   * 滞在・トランジット選択 stayInUS:滞在 transit:トランジット
   */
  stayOrTransit?: PostCheckinTravelersRequestTravelersInnerRegulatoryDetailsSecondaryDocumentsInnerAddress.StayOrTransitEnum;
  /**
   * 郵便番号
   */
  zipCode?: string;
  /**
   * 州名
   */
  state?: string;
  /**
   * 都市名
   */
  city?: string;
  /**
   * 住所（ホテル名）
   */
  line?: string;
}
export namespace PostCheckinTravelersRequestTravelersInnerRegulatoryDetailsSecondaryDocumentsInnerAddress {
  export type StayOrTransitEnum = 'stayInUS' | 'transit';
  export const StayOrTransitEnum = {
    StayInUs: 'stayInUS' as StayOrTransitEnum,
    Transit: 'transit' as StayOrTransitEnum,
  };
}
